import { moduleThemeNames } from "./moduleThemeNames";

export default {
  [moduleThemeNames.SET_THEME](state: any, payload: any) {
    state.active = payload;
  },
};
